import { RootState } from '../store';

export const getImportStatus = (state: RootState) => state.database.status;
export const getImportTextStatus = (state: RootState) => state.database.importTextStatus;
export const getImportProgress = (state: RootState) => state.database.progress;
export const getImportKey = (state: RootState) => state.database.key;
